import {Comment} from "./Comment";
import React from "react";


export class Fetcher {
    url: string;
    inProgress: boolean = false;
    errorsArray: string[] = [];
    onChange: (() => void) | null = null;
    responseStatus: number | null = null;
    responseStatusText: string | null = null;

    constructor(url: string) {
        this.url = url;
    }

    reset() {
        this.errorsArray = [];
        this.changed();
    }

    isInProgress(): boolean {
        return this.inProgress
    }

    hasErrors():boolean {
        return this.errorsArray.length > 0;
    }

    errors():string[] {
        return this.errorsArray;
    }

    changed(): void {
        if (this.onChange) {
            this.onChange();
        }
    }

    post(body: any, callback: ((json: any) => void) | null = null) {
        this.fetch('POST', body, null, callback);
    }

    postQuery(body: any, queryParams: any | null = {}, callback: ((json: any) => void) | null = null) {
        this.fetch('POST', body, queryParams, callback);
    }

    get(queryParams: any | null = {}, callback: ((json: any) => void) | null = null) {
        this.fetch('GET', null, queryParams, callback);
    }

    fetch(method: string = 'POST', body: any | null, queryParams: (any | null) = null, callback: ((json: any) => void) | null = null) {
        this.errorsArray = [];
        let urlWithQueryString = this.url;
        if (queryParams) {
            urlWithQueryString += "?" + new URLSearchParams(queryParams);
        }
        let fetch_options: any = {
            method: method,
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}
        };
        if (body) {
            fetch_options.body = JSON.stringify(body)
        }
        this.inProgress = true;
        this.changed();

        fetch(urlWithQueryString, fetch_options).then(response => {
            let responseJson = response.json()
            console.log("Fetcher Response", response);
            console.log("Fetcher JSON", responseJson);
            this.responseStatus = response.status;
            this.responseStatusText = response.statusText;
            // if (response.status >= 400) {
            //     throw new Error("Server responds with error!");
            // }
            return responseJson;
        })
            .then(json => {
                    console.log("Response JSON", json);
                    if(this.responseStatus == null || this.responseStatus < 400) {
                        if (callback) {
                            callback(json);
                        }
                    } else {
                        let errors = json.errors;
                        if(errors) {
                            this.errorsArray = errors;
                        } else if (json.error) {
                            this.errorsArray = [`${json.error}`];
                        } else {
                            this.errorsArray = ["Missing error."]
                        }
                    }
                },
                err => {
                    console.log("err", err);
                    this.errorsArray = [`Received error: ${this.responseStatus} ${this.responseStatusText}`];
                })
            .catch((error) => {
                this.errorsArray = [`Caught error: ${error}`];
            })
            .finally(() => {
                    this.inProgress = false;
                    this.changed();
                }
            )
    }

    renderErrors() {
        return <>
            { this.hasErrors() && <>
                <div className="row my-2">
                    <div className="md-12 text-center alert alert-danger">
                        {this.errors().map((error) => {
                            return <>{error}<br/></>
                        })}
                    </div>
                </div>
            </>}
        </>
    }
}
